import React from 'react';

// Layout
import { Layout } from './../components/Layout';

// Fields
import { SEO } from './../components/Seo';
import Headings from './../components/Headings';
import { FeedbackForm } from './../components/FeedbackForm';

const Feedback = () => {
    const title = 'Feedback';
    return (
        <Layout>
            <SEO title={title} />
            <div className="title-content">
                <Headings>{title}</Headings>
            </div>
            <div className="white-content">
                <div className="main">
                    <FeedbackForm />
                </div>
            </div>
        </Layout>
    );
};

Feedback.propTypes = {
    //
};

export default Feedback;
